const environment = process.env.REACT_APP_API_URL;
export const apiUrl = process.env.REACT_APP_API_URL;

export default environment;
